import {
    HotkeyBinding,
    View,
} from 'radpresentation.htmlclient.defaultviewextensions';
import type EditPropertyGroupViewViewModel from '@/ViewModels/Views/EditPropertyGroupViewViewModel';
import layout from './EditPropertyGroupView.html?raw';

class EditPropertyGroupView extends View {
    private view: JQuery<HTMLElement>;

    constructor(
        private viewModel: EditPropertyGroupViewViewModel,
        private element: any
    ) {
        super();
    }

    public getView(): JQuery<HTMLElement> {
        if (this.view != null) {
            return this.view;
        }

        this.view = this.applyBindings(this.element, this.viewModel, layout);

        let $dropDownControls = this.view.find('.c-dropdownlist');

        let $view = this.view;
        let stopPropagation = () => false;

        HotkeyBinding.addHotkey(
            $view[0],
            'esc',
            this.viewModel.cancel.onClick.bind(this)
        );
        HotkeyBinding.addHotkey($dropDownControls[0], 'esc', stopPropagation);
        HotkeyBinding.addHotkey($dropDownControls[1], 'esc', stopPropagation);
        HotkeyBinding.addHotkey($dropDownControls[2], 'esc', stopPropagation);

        HotkeyBinding.addHotkey(
            $view[0],
            'enter',
            this.viewModel.okay.onClick.bind(this)
        );
        HotkeyBinding.addHotkey($dropDownControls[0], 'enter', stopPropagation);
        HotkeyBinding.addHotkey($dropDownControls[1], 'enter', stopPropagation);
        HotkeyBinding.addHotkey($dropDownControls[2], 'enter', stopPropagation);

        return this.view;
    }
}
export default EditPropertyGroupView;
